import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class extends Component {
	render() {
		return (
			<div className="cards cards-question">
				<div className="question">
					У вас уже есть электронная карта?
				</div>
				<div className="buttons">
					<Link to="/card/create" className="answer answer-yes">Нет, я хочу создать новую карту!</Link>
					<Link to="/card/find" className="answer answer-no">Да, я хочу найти мою карту</Link>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/card/Question.js